import { useLightMode } from '@/hooks/useLightMode'

import { Text, tokenPrefix } from '@hivewatch/dark'

import { IncidentNoteMediaIProps } from '../../../shared/types/feedTypes'

export const FileDescription = ({ files }: IncidentNoteMediaIProps) => {
  const prefix = tokenPrefix(useLightMode())

  if (files.length === 1) {
    return (
      <Text color={`${prefix}text.secondary`} fontSize='sm' mr='10px'>
        {files[0].name}
      </Text>
    )
  } else {
    return (
      <Text color={`${prefix}text.secondary`} fontSize='sm' mr='10px'>
        {files.length} files
      </Text>
    )
  }
}
